import styled from 'styled-components';
import { GatsbyImage } from "gatsby-plugin-image";

export const ExampleImg = styled(GatsbyImage)`
    width: 734px;
`;
